export default {
    data() {
        return {};
    },
    methods: {
        printLabels() {
            this.loading = true;
            let isForClients = this.role === 'user' ? 1 : 0;
            axios({
                url: `/colli/print-labels?isForClients=${isForClients}&isPrintByBooking=1&groupByBooking=1`,
                method: 'POST',
                data: {ids: this.bookings}
            }).then((response) => {
                if (response.data.printnode === 'missing printer') {
                    alert('PDF generated, but not sent to print since printer id is missing');
                }
                if (response.data.file !== null) {
                    axios({
                        url: `/settings/download-file/print_labels_${response.data.file}`,
                        method: 'GET',
                        responseType: 'blob'
                    }).then((response) => {
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', `print_label.pdf`);
                        document.body.appendChild(fileLink);
                        fileLink.click();
                    }).catch((error) => {
                        console.log(error)
                    });
                } else if(response.data.printnode !== 'missing printer') {
                    alert('No data');
                }
            }).catch((error) => {
                console.log(error)
            }).finally(() => {
                this.loading = false;
                this.bookings = {};
            });
        },
    },
};
